"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.changeTitle = void 0;
const effects_1 = require("redux-saga/effects");
const title_1 = __importDefault(require("src/utils/title"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const i18n = (0, i18n_1.default)(['page']);
function* changeTitle() {
    yield (0, effects_1.call)(title_1.default, i18n(['title']));
}
exports.changeTitle = changeTitle;
function* router() {
    yield (0, effects_1.takeEvery)('LANG_SET', changeTitle);
}
exports.router = router;
